<form [formGroup]="form">
  <fieldset>
    <div class="form-row">
      <div class="col-12 mb-3">
        <label class="label">Pertinence de la mission *</label>
        <div class="form-text mb-1">Décrivez la pertinence de la mission pour justifier le renouvellement.</div>
        <mat-form-field class="full-width">
          <textarea matInput [placeholder]="nbreCaratereTextarea1" formControlName="pertinenceMission" rows="4"
          required></textarea>
          @if (form.get('pertinenceMission')?.hasError('required') || form.get('pertinenceMission')?.hasError('whitespace') && form.get('pertinenceMission')?.touched) {
            <mat-error
              >
              Ce champ ne peut pas être vide ou contenir uniquement des espaces.
            </mat-error>
          }
          @if (form.get('pertinenceMission')?.errors?.['maxlength']) {
            <mat-error> Le texte ne doit pas dépasser 350
            caractères </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="col-12 mb-3">
        <label class="label">Renouvellement à justifier *</label>
        <div class="form-text mb-1">Expliquez pourquoi le renouvellement est à justifier.</div>
        <mat-form-field class="full-width">
          <textarea matInput [placeholder]="nbreCaratereTextarea2" formControlName="renouvellementAJustifier" rows="4"
          required></textarea>
          @if (form.get('renouvellementAJustifier')?.hasError('required') || form.get('renouvellementAJustifier')?.hasError('whitespace') && form.get('renouvellementAJustifier')?.touched) {
            <mat-error
              >
              Ce champ ne peut pas être vide ou contenir uniquement des espaces.
            </mat-error>
          }
          @if (form.get('renouvellementAJustifier')?.errors?.['maxlength']) {
            <mat-error>
              Le texte ne doit pas dépasser 720 caractères
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </fieldset>
</form>